import axios from 'axios'

const state = {
    recommendation_doctors: [],
    recommendation_orders: [],
    recommendation_services: [],
    recommendation_loading: false,
    total_recommendation_doctors: 0,
}

const getters = {
    recommendation_doctors: state => state.recommendation_doctors,
    recommendation_services: state => state.recommendation_services,
    recommendation_orders: state => state.recommendation_orders,
    recommendation_loading: state => state.recommendation_loading,
}

const mutations = {
    setRecommendationDoctors(state, recommendation_doctors) {
        state.recommendation_doctors = recommendation_doctors
    },
    setRecommendationOrders(state, recommendation_orders) {
        state.recommendation_orders = recommendation_orders
    },
    setRecommendationsLoading(state, recommendation_loading) {
        state.recommendation_loading = recommendation_loading
    },
    setRecommendationServices(state, recommendation_services) {
        state.recommendation_services = recommendation_services
    }
}

const actions = {

    getRecommendationDoctors({commit}, params) {
        commit('setRecommendationsLoading', true)
        axios.get(`/api/doctors/recommendations/${params.tab}/doctors`, {params})
            .then(response => {
                commit('setRecommendationDoctors', response.data)
                commit('setRecommendationsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setRecommendationsLoading', false)
            })
    },
    getRecommendationServices({commit}, params) {
        commit('setRecommendationsLoading', true)
        axios.get(`/api/doctors/recommendations/${params.tab}/services`, {params})
            .then(response => {
                commit('setRecommendationServices', response.data)
                commit('setRecommendationsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setRecommendationsLoading', false)
            })
    },
    getRecommendationOrders({commit}, params) {
        commit('setRecommendationsLoading', true)
        axios.get(`/api/doctors/recommendations/${params.tab}/orders`, {params})
            .then(response => {
                commit('setRecommendationOrders', response.data)
                commit('setRecommendationsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setRecommendationsLoading', false)
            })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}